import React from 'react';
import PropTypes from 'prop-types';

const OwnerText = ({ owner }) => {
  let text;
  if (owner === false) {
    text = 'Shared with you';
  } else {
    text = 'Created by you';
  }

  return <span>{text}</span>;
};

OwnerText.propTypes = {
  owner: PropTypes.bool,
};

export default OwnerText;



// WEBPACK FOOTER //
// ./library/app/components/Global/Conversions/OwnerText.js